document.addEventListener('DOMContentLoaded', function() {
    var toggle = document.getElementById('mobile-menu-toggle');
    var menu = document.getElementById('mobile-menu');
    var header = document.getElementById('site-header');
    if (toggle && menu && header) {
        // On utilise max-height pour l'animation smooth
        menu.style.overflow = 'hidden';
        menu.style.maxHeight = '0px';
        menu.style.transition = 'max-height 0.5s cubic-bezier(0.77,0,0.175,1)';
        function getHeaderHeight() {
            return header.offsetHeight;
        }
        function getMenuContentHeight() {
            // On clone le menu pour mesurer la hauteur réelle du contenu
            var clone = menu.cloneNode(true);
            clone.style.visibility = 'hidden';
            clone.style.position = 'absolute';
            clone.style.height = 'auto';
            clone.style.maxHeight = 'none';
            clone.style.top = '-9999px';
            document.body.appendChild(clone);
            var height = clone.scrollHeight;
            document.body.removeChild(clone);
            return height;
        }
        function openMenu() {
            // Place le menu juste sous le header
            //menu.style.top = getHeaderHeight() + 'px';
            // En fait on le fait partir de tout en haut
            menu.style.top = 0;
            menu.classList.add('open');
            // Mesure la hauteur réelle du contenu
            var contentHeight = getMenuContentHeight();
            //menu.style.maxHeight = contentHeight + 'px';
            menu.style.maxHeight = '100vh';
            
            // Désactiver le scroll de la page
            //document.body.style.overflow = 'hidden';
            //document.documentElement.style.overflow = 'hidden';
            
            // Transformer l'icône burger en croix
            toggle.classList.add('active');
        }
        function closeMenu() {
            menu.classList.remove('open');
            menu.style.maxHeight = '0px';
            
            // Réactiver le scroll de la page
            //document.body.style.overflow = '';
            //document.documentElement.style.overflow = '';
            
            // Remettre l'icône burger normale
            toggle.classList.remove('active');
        }
        toggle.addEventListener('click', function() {
            var isOpen = menu.classList.contains('open');
            if (!isOpen) {
                openMenu();
            } else {
                closeMenu();
            }
        });
        
        // Fermer le menu avec la touche Escape
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && menu.classList.contains('open')) {
                closeMenu();
            }
        });
        window.addEventListener('resize', function() {
            menu.style.top = getHeaderHeight() + 'px';
            if (menu.classList.contains('open')) {
                var contentHeight = getMenuContentHeight();
                //menu.style.maxHeight = contentHeight + 'px';
                menu.style.maxHeight = '100vh';
                
                // Fermer le menu si on passe en desktop (évite les problèmes de scroll)
                if (window.innerWidth >= 1024) { // lg breakpoint
                    closeMenu();
                }
            }
        });
        // Initialisation
        menu.style.top = getHeaderHeight() + 'px';
    }
});
